import { authFetch, throwApiError } from './core'
import { buildAgentUrl } from './core'
import { getBackendUrl } from '../../lib/backendUrl'
import { requestOptions } from './workspace'

export interface ChangeStudentMascotPayload {
  memberId: string
  username: string
}

export interface ResetStudentPinPayload {
  memberId: string
  secretIds: string[]
}

export interface ForceStudentSelfPasswordPayload {
  newPassword: string
}

export async function changeStudentMascot(
  _token: string,
  payload: ChangeStudentMascotPayload,
): Promise<{ memberId: string; username: string }> {
  const response = await authFetch(`${getBackendUrl()}/api/identity/users/me/username`, {
    method: 'PATCH',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username: payload.username }),
  })
  if (!response.ok) {
    await throwApiError(response, 'Failed to update student mascot')
  }
  return { memberId: payload.memberId, username: payload.username }
}

export async function changeManagedStudentMascot(
  token: string,
  payload: ChangeStudentMascotPayload,
): Promise<{ memberId: string; userId: string; username: string }> {
  const response = await authFetch(buildAgentUrl('/students/username'), {
    method: 'PATCH',
    ...requestOptions(token, { 'Content-Type': 'application/json' }),
    body: JSON.stringify(payload),
  })
  if (!response.ok) {
    await throwApiError(response, 'Failed to update student mascot')
  }
  return response.json() as Promise<{ memberId: string; userId: string; username: string }>
}

export async function resetStudentPin(
  _token: string,
  payload: ResetStudentPinPayload,
): Promise<{ memberId: string; userId: string; secretIds: string[] }> {
  const response = await authFetch(`${getBackendUrl()}/api/agent/students/password/reset`, {
    method: 'PATCH',
    ...requestOptions(_token, { 'Content-Type': 'application/json' }),
    body: JSON.stringify(payload),
  })
  if (!response.ok) {
    await throwApiError(response, 'Failed to reset student pin')
  }
  return response.json() as Promise<{ memberId: string; userId: string; secretIds: string[] }>
}

export async function forceUpdateOwnStudentPassword(
  _token: string,
  payload: ForceStudentSelfPasswordPayload,
): Promise<void> {
  const response = await authFetch(`${getBackendUrl()}/api/identity/users/me/password/force`, {
    method: 'PATCH',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      newPassword: payload.newPassword,
    }),
  })
  if (!response.ok) {
    await throwApiError(response, 'Failed to update picture secret')
  }
}
